export type FolderSortKey = 'name' | 'dateModified' | 'size' | 'dateCreated';

/** What an item is sorted by, the same for a folder in the listing, a project and a folder of the tree. */
interface SortedItem {
  name: string;
  dateCreated: string;
  dateModified: string;
  /** A project's file size in bytes. */
  size?: number;
  /** How many folders and projects a folder holds, which a folder is sized by. */
  itemCount?: number;
}

/** Each sorts one way, as in Finder: a name A to Z, a size the largest first, a date the newest first. */
export const sortDirection = (key: FolderSortKey) => (key === 'name' ? 'asc' : 'desc');

/** Orders two items by `key`, the listing's and the tree's alike, so the two never disagree. */
export const compareItems = (key: FolderSortKey, language: string, a: SortedItem, b: SortedItem) => {
  let order: number;
  if (key === 'name') order = a.name.localeCompare(b.name, language, { numeric: true });
  // By size, a folder goes by how many items it holds and a project by its bytes. Folders and
  // projects are listed apart, so how one weighs against the other never shows.
  else if (key === 'size') order = (a.size ?? a.itemCount ?? 0) - (b.size ?? b.itemCount ?? 0);
  else order = new Date(a[key]).getTime() - new Date(b[key]).getTime();

  return sortDirection(key) === 'asc' ? order : -order;
};
